var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory, SurveyElementBase, List } from "survey-react-ui";
var TabJsonEditorErrorsComponent = /** @class */ (function (_super) {
    __extends(TabJsonEditorErrorsComponent, _super);
    function TabJsonEditorErrorsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabJsonEditorErrorsComponent.prototype.getStateElement = function () {
        return this.model;
    };
    Object.defineProperty(TabJsonEditorErrorsComponent.prototype, "model", {
        get: function () {
            return this.props.data;
        },
        enumerable: false,
        configurable: true
    });
    TabJsonEditorErrorsComponent.prototype.renderElement = function () {
        return React.createElement("div", { className: "svc-json-editor-tab__errros_list", style: { display: this.model.hasErrors ? "block" : "none" } },
            React.createElement(List, { model: this.model.errorList }));
    };
    return TabJsonEditorErrorsComponent;
}(SurveyElementBase));
export { TabJsonEditorErrorsComponent };
var TabJsonEditorTextareaComponent = /** @class */ (function (_super) {
    __extends(TabJsonEditorTextareaComponent, _super);
    function TabJsonEditorTextareaComponent(props) {
        return _super.call(this, props) || this;
    }
    TabJsonEditorTextareaComponent.prototype.getStateElement = function () {
        return this.model;
    };
    Object.defineProperty(TabJsonEditorTextareaComponent.prototype, "model", {
        get: function () {
            return this.props.data;
        },
        enumerable: false,
        configurable: true
    });
    TabJsonEditorTextareaComponent.prototype.renderElement = function () {
        var _this = this;
        var setControl = function (el) {
            _this.model.textElement = el;
        };
        var errors = React.createElement(TabJsonEditorErrorsComponent, { data: this.model });
        return (React.createElement("div", { className: "svc-creator-tab__content" },
            React.createElement("div", { className: "svc-json-editor-tab__content" },
                React.createElement("textarea", { ref: function (input) { return (setControl(input)); }, className: "svc-json-editor-tab__content-area", value: this.model.text, onChange: function (e) {
                        return (_this.model.text = e.target.value);
                    }, onKeyDown: function (e) { return _this.model.checkKey(e, e); }, disabled: this.model.readOnly, "aria-label": this.model.ariaLabel }),
                errors)));
    };
    return TabJsonEditorTextareaComponent;
}(SurveyElementBase));
export { TabJsonEditorTextareaComponent };
ReactElementFactory.Instance.registerElement("svc-tab-json-editor-textarea", function (props) {
    return React.createElement(TabJsonEditorTextareaComponent, props);
});
